export default "<app-report-orders\n [customers]=\"customers\"\n (exportExcel)=\"onExportExcel($event)\"\n></app-report-orders>\n"